module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "windows_95_logo.415a4b03.png" + "?" + Date.now();